module.exports = __webpack_public_path__ + "static/img/logo35.8f3de2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo35.png
// module id = HZce
// module chunks = 1